"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPropertyDocumentEnquiryDto = instanceOfPropertyDocumentEnquiryDto;
exports.PropertyDocumentEnquiryDtoFromJSON = PropertyDocumentEnquiryDtoFromJSON;
exports.PropertyDocumentEnquiryDtoFromJSONTyped = PropertyDocumentEnquiryDtoFromJSONTyped;
exports.PropertyDocumentEnquiryDtoToJSON = PropertyDocumentEnquiryDtoToJSON;
exports.PropertyDocumentEnquiryDtoToJSONTyped = PropertyDocumentEnquiryDtoToJSONTyped;
/**
 * Check if a given object implements the PropertyDocumentEnquiryDto interface.
 */
function instanceOfPropertyDocumentEnquiryDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('fileId' in value) || value['fileId'] === undefined)
        return false;
    if (!('fileName' in value) || value['fileName'] === undefined)
        return false;
    if (!('fileUrl' in value) || value['fileUrl'] === undefined)
        return false;
    if (!('fileType' in value) || value['fileType'] === undefined)
        return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined)
        return false;
    return true;
}
function PropertyDocumentEnquiryDtoFromJSON(json) {
    return PropertyDocumentEnquiryDtoFromJSONTyped(json, false);
}
function PropertyDocumentEnquiryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'fileId': json['fileId'],
        'fileName': json['fileName'],
        'fileUrl': json['fileUrl'],
        'fileType': json['fileType'],
        'displayOrder': json['displayOrder'],
    };
}
function PropertyDocumentEnquiryDtoToJSON(json) {
    return PropertyDocumentEnquiryDtoToJSONTyped(json, false);
}
function PropertyDocumentEnquiryDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'fileId': value['fileId'],
        'fileName': value['fileName'],
        'fileUrl': value['fileUrl'],
        'fileType': value['fileType'],
        'displayOrder': value['displayOrder'],
    };
}
